// Each scope's own heading, taken verbatim from the source workbook (one
// sheet per scope, each with its own title row — R02 and R06 do not follow
// the "DATA SKOP KERJA <scope>" pattern R01 uses).
//
// Sibling to colors.js rather than folded into it: this is workbook text, not
// workbook fill colour, but it's shared the same way — the export and the
// table component should both read from here rather than one of them
// inlining a switch on `scope`.
export const KJP_TITLES = {
  R01: 'DATA SKOP KERJA R01 PAVEMENT',
  R02: 'DATA ROAD SHOULDER (R02)',
  R06: 'DATA ROADLINE MARKING (R06)',
}
